import { Fade, IconButton, makeStyles, AppBar, Grid, Tabs, Tab, Tooltip, Button, Typography } from '@material-ui/core';
import Popper from '@material-ui/core/Popper';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import { useDispatch } from 'react-redux';
import { handleSnackBar, invokeGetService } from '../../../store/global/actions';
import { useEffect, useRef, useState } from 'react';
import useDebounce from '../../../hooks/useDebounce';
import TabPanel from '../../tabs/TabPanel';
import { addAssets } from '../../../store/assets/actions';
import { getDetailsFromUrl } from '../../../services/blueprint';
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress.js';

const useStyles = makeStyles(() => ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '6px',
        boxShadow: '0px 0px 30px rgba(0,0,0,0.2)',
        overflow: 'hidden',
        background: '#ffffff',
    },
    header: {
        background: '#3f4e5c',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    closeIconBtn: {
        fontSize: '6px',
        padding: 0,
        height: 'max-content',
        color: '#ffffff',
        marginTop:'-8px'
    },
    searchWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '0.3px solid #bebebe',
        padding:  '8px 12px'
    },
    searchInput: {
        border: 'none',
        outline: 'none',
    },
    searchSelect: {
        height: '100%',
        borderRadius: '0px',
        border: '0.3px solid #bebebe',
        padding: '6px 10px',
        background: '#ffffff',
        outline: 'none',
        fontSize: '0.8rem',
        marginRight:'10px',
        fontWeight: 'bold'
    },
    selectOptions: {
        padding: '6px 10px',
    },
    iconsContainer: {
        display: 'flex',
        gap: '0.3rem',
        padding: '0.5rem',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        width: '100%'
    },
    iconCard: {
        width: 'calc((100% - 0.9rem) / 4)',
        aspectRatio: '1/1',
        background: '#e3e3e3',
        padding: '0.8rem',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center'
    },
    icon: {
        height: '100%'
    },
    appBar: {
        height: 40, 
    },
    tabRoot: {
        minWidth: 50, 
        paddingLeft: "20px",
        paddingRight: "20px",
        paddingBottom: "10px", 
        fontSize: "12px",
    },
    tabsScroller: {
        height: 40,
    },
    imgContainer: {
        width: 40,
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2px',
        margin: '0px 5px',
        marginBottom: '5px',
        border: 'solid 2px #000',
        borderRadius: 50,
        '&:hover': {
          cursor: 'pointer',
          border: 'solid 2px #3f4e5c'
        },
    },  
    uploadBtn: {
        padding: 5,
        fontSize: '13px',
        textTransform: 'capitalize'
    },
    noMatch: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '8rem'
    }
}))

export function IconPopper({id, open, setOpen, selectedIcon, setSelectedIcon, anchorEl, defaultSearchTag, blueprint_id, slug, isBlueprintCreate}) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const fileInputRef = useRef(null);
    let blueprintId = "";
    let blueprint_slug = "";
    if(blueprint_id && slug){
        blueprintId = blueprint_id;
        blueprint_slug = slug;
    }else{
        blueprintId = getDetailsFromUrl()?.blueprintId;
        blueprint_slug = getDetailsFromUrl()?.slug;
    }

    const [query, setQuery] = useState(null);
    const debouncedQuery = useDebounce(query, 500);
    const [icons, setIcons] = useState([]);
    const [isIconsOver, setIconsOver] = useState(false)
    const [next, setNext] = useState(null);
    const [cacheNext , setCacheNext] = useState(null);
    const [iconPack, setIconPack] = useState(1)
    const [value, setValue] = useState(0);
    const [isCustomIconsLoading, setCustomIconsLoading] = useState(false)
    const [renderCounter, setRenderCounter] = useState(0)
    const [customIconList, setCustomIconList] = useState(null)
    const [loading, setLoading] = useState(false);

    const handleSearchIcons = async (query, next) => {
        setLoading(true);
        const params = {keyword: query, library: iconPack, blueprintId};
        if(next){
            params.next_page = next;
        }else if(cacheNext){
            params.cache_next = cacheNext
        }
       try {
        const result = await dispatch(invokeGetService('searchIcons', params));
        setLoading(false);
        if(result && result.status){
            setIcons(prev => [...prev, ...(result?.data?.icons || [])])
            if(result?.data?.icons?.length === 0){
                setIconsOver(true);
            }
            if(result?.data?.next){
                setNext(result?.data?.next);
                setCacheNext(null);
            }else if(result?.data?.cache_next){
                setCacheNext(result?.data?.cache_next);
                setNext(null);
            }else{
                setNext(null);
                setCacheNext(null);
                setIconsOver(false);
            }
        }
       } catch (error) {
        console.error("Hanlding search icons failed.  ", error)
       }
    }

    const LoadMoreIcons = async () => {
        handleSearchIcons(debouncedQuery, next)
    }

    const onSelectIcon = (iconData) => {
        setSelectedIcon(iconData);
        setOpen(false);
        resetStates();
    }

    const handleCustomUpload = () => {
        fileInputRef.current.click();
    }

    const handleIconChange = async (event) => {
        if(event.target?.files[0]){
          const formData = new FormData();
          formData.append('blueprintId', blueprintId )
          formData.append('assetDescription', '' )
          formData.append('assetFile', event?.target?.files[0] )
          formData.append('type', "file" )
          formData.append('parent', null )
          formData.append('source', "icons" )
          
          const response = await dispatch(addAssets(formData));
        
          if(response.status){
            dispatch(handleSnackBar({open: true, message: "Icon uploaded successfully", severity: "success"}))
          }else{
            dispatch(handleSnackBar({open: true, message: response.message, severity: "error"}))
          }
        }

        setRenderCounter(prev => prev + 1)
    }

    const getCustomIcons = async () => {
      setCustomIconsLoading(true)
    //   const response = await dispatch(invokeGetService('getCustomIcons',[blueprint_slug]))
      const response = await dispatch(invokeGetService('getCustomIcons',{slug: blueprint_slug, blueprintId}))
      if(response.status){
        setCustomIconList(response?.data)
      }
      setCustomIconsLoading(false)
    }

    const onTabChange = (e, v) => {
        setValue(v);
    }

    const handleClose = () => {
        setOpen(false);
        setValue(0);
        resetStates();
    }

    const resetStates = () => {
        setCacheNext(null);
        setNext(null);
        setIconsOver(false);
        setQuery(null);
    }


    useEffect(() => {
        if(debouncedQuery?.length > 1){
            handleSearchIcons(debouncedQuery);
        }
    }, [debouncedQuery])


    useEffect(() => {
        if(open && defaultSearchTag) {
            setLoading(true);
            setQuery(defaultSearchTag.replace(/[^a-zA-Z0-9 ]/g, ' ').toLowerCase());
        }
    }, [open])
 

    useEffect(() => {
        if(!query || query === '' || query.length === 1) {
            setIcons([]);
            setNext(null);
            setCacheNext(null);
            setIconsOver(false);
        }  
    }, [query])

    useEffect(() => {
        if(value === 1){
          getCustomIcons();
        }
    },[value, renderCounter])
    
    return (
        <Popper id={`${id}_popper`} open={open} style={{zIndex: 10000}} anchorEl={anchorEl} disablePortal transition>
            {({ TransitionProps }) => (
              <Fade {...TransitionProps}>
                <div className={classes.paper}>
                    <AppBar position="static" className={classes.appBar}>
                        <Grid container alignItems="center">
                            <Grid item xs={11}>
                                <Tabs value={value} onChange={onTabChange} classes={{ scroller: classes.tabsScroller }}>
                                    <Tab label="Icon Library" classes={{ root: classes.tabRoot }}/>
                                    <Tab label="Upload Icon" disabled={isBlueprintCreate} classes={{ root: classes.tabRoot }}/>
                                </Tabs>
                            </Grid>
                            <Grid item xs={1}>
                                <Tooltip title={"Close"}>
                                    <IconButton className={classes.closeIconBtn} id={"icons-close-button"} onClick={handleClose}>
                                        <CloseIcon fontSize='small'/>
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </AppBar>

                    <TabPanel value={value} index={0} id='icon_library' boxStyle={{padding: 0}}>
                        <div className={classes.searchWrapper}>
                            <select className={classes.searchSelect} id="icon_pack_seletor" onChange={(e) => setIconPack(e.target.value)}>
                                <option className={classes.selectOptions} value={1}>Icon Pack 1</option>
                                <option className={classes.selectOptions} value={2}>Icon Pack 2</option>
                            </select>
                            <input placeholder='Search icons...' id="searchIconInput" value={query} onChange={(event) => setQuery(event.target.value)} className={classes.searchInput} />
                            <IconButton className={classes.closeIconBtn} style={{color: '#000000', margin: 'auto'}}>
                                <SearchIcon />
                            </IconButton>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', height: '20rem', overflowY: 'auto', width: '22rem'}}>
                            <div className={`${classes.iconsContainer} icons-list-container`}>
                                { icons?.length !== 0 &&
                                   icons?.map((icon) => (
                                        <div key={icon.id} onClick={() => onSelectIcon(icon)} className={`${classes.iconCard} icon_card`}>
                                            <img className={classes.icon} src={icon.link} />
                                        </div>
                                    ))
                                }
                                {   
                                    loading && 
                                    <div id={"icons-loading"} style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
                                        <LoaderWithProgress size={18} isContent={true} styleRoot={{ marginTop: '8rem' }}/>
                                    </div>
                                }
                            </div>
                            {((next || cacheNext) && !loading) && !isIconsOver && 
                                <Button onClick={LoadMoreIcons} style={{marginBottom: '0.5rem', fontWeight: 500}}>Load More</Button>
                            } 
                            {!loading && icons.length == 0 &&
                                <div className={classes.noMatch}>
                                    <Typography>No matches found</Typography>
                                </div>
                            }
                        </div>
                        
                    </TabPanel>

                    <TabPanel value={value} index={1} id='upload_icon' boxStyle={{padding: 0}}>
                        <input type='file' id='custom-icon-input' hidden accept='image/*' onChange={handleIconChange} ref={fileInputRef}/>


                        <div style={{ display: "flex", justifyContent: "flex-end", padding: '8px 12px' }}>
                            <Button id="upload_icon_button" variant="contained" color="primary" size="small" className={classes.uploadBtn} onClick={handleCustomUpload}>Upload Icon</Button>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', height: '20rem', overflowY: 'auto', width: '22rem'}}>
                            <div className={`${classes.iconsContainer} uploaded-icons-container`}>
                                {
                                   customIconList && customIconList?.map((icon) => (
                                        <div key={icon.id} title={icon?.data?.assetName?.split(".")[0]} onClick={() => onSelectIcon(icon)} className={`${classes.iconCard} icon_card`}>
                                            <img className={classes.icon} src={icon?.filePath} />
                                        </div>
                                    ))
                                }
                                {
                                    (!customIconList || customIconList?.length === 0) &&
                                    <div className={`${classes.noMatch} no-icons-alert`} style={{width: '100%'}}>
                                        <Typography>No icons added yet!</Typography>
                                    </div>
                                }
                            </div>
                        </div>
                    </TabPanel>

                </div>
              </Fade>
            )}
        </Popper>
    )
}